//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** List of System Guids for OIDC Scopes. */
export const AuthScope = {
    /** The address scope */
    Address: "F12EEBE7-7CE4-46C5-80DA-A2208011216E",
    /** The email scope */
    Email: "27F77AE2-81A2-4602-B530-8D75376201F2",
    /** The offline scope */
    Offline: "580662DE-EE9B-4CA2-847A-615B7E61E15B",
    /** The phone scope */
    Phone: "3AF58238-D3B9-4FCE-971C-A55BEB51241E",
    /** The profile scope */
    Profile: "5FE34F25-288A-48C7-AAE1-F471EADCE1EE",
};
